import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { NeededPartItem } from '../neededpartitem';
import { LaborGuideItem } from '../labor-guide-item';
import { LaborService } from "../labor.service";
import { LaborsearchComponent } from '../laborsearch/laborsearch.component';

@Component({
  selector: 'app-labordialog',
  templateUrl: './labordialog.component.html',
  styleUrls: ['./labordialog.component.css']
})
export class LabordialogComponent implements OnInit {
  neededParts: NeededPartItem[] = [];
  lgItem = new LaborGuideItem(0, 0, '', '', 0, '', '', '', false, 0, 1, "");
  labors = [];
  allLabors = [];
  // selectedLabor: any;
  mode: string;
  selectedParentId: any;
  laborType: string = '';
  parentLabor: any;
  // anotherOption: false;
  parentName: string = '';
  isLoading: boolean = false;
  // currentVinNumber = '';
  quantities: string[] = ['1', '2', '3', '4', '5', 'Specification'];

  constructor(
    private dialogRef: MatDialogRef<LabordialogComponent>,
    private laborService: LaborService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    this.mode = data.mode;
    this.allLabors = data.labors;
    if (data.mode != 'addLabor') {
      this.labors = data.labors.sort(function (a, b) {
        if (a.Title < b.Title) return -1;
        if (a.Title > b.Title) return 1;
        return 0;
      });;
      // this.selectedLabor = data.selectedLabor;
      let currentLabor = data.selectedLabor;
      this.laborType = currentLabor.Type;
      // this.currentVinNumber = data.currentVinNumber;

      if (this.mode == 'edit') {
        this.selectedParentId = currentLabor.ParentId; // get laborguide parent id
        this.loadData(currentLabor.AddonId);
        this.parentName = currentLabor.ParentName;
      } else {
        this.parentName = currentLabor.Title;
        this.selectedParentId = currentLabor.LaborGuideId; // get laborguide parent id
      }
    }
  }

  setParentCat($event): void {
    let cat = $event;
    this.parentName = cat.Name;
    this.selectedParentId = cat.LaborGuideId;
  }

  loadData(laborId: any) {
    this.isLoading = true;
    this.laborService.getLaborById(laborId)
      .subscribe(data => {
        this.lgItem = data.Labor;
        // for (var i = 0; i < data.NeededParts.length; i++) {
        //   if (data.NeededParts[i].Quantity == 0) {
        //     data.NeededParts[i].QuantityValue = "Specification";
        //   } else {
        //     data.NeededParts[i].QuantityValue = data.NeededParts[i].Quantity.toString();
        //   }
        // }
        // this.neededParts = data.NeededParts;
        this.isLoading = false;
      })
  }

  verifyLabor(isVerified: any) {
    this.lgItem.IsVerified = isVerified;
    this.laborService.updateLabor(this.lgItem, this.neededParts)
      .subscribe(result => {
        this.dialogRef.close({
          neededParts: this.neededParts,
          laborItem: this.lgItem
        });
      });
  }

  ngOnInit() {
    // this.addNewItem();
  }

  save() {
    this.isLoading = true;
    // this.neededParts = this.neededParts.filter(ele => {
    //   return ele.Name != '';
    // })

    // this.neededParts.forEach(n => {
    //   if (n.QuantityValue == "Specification") {
    //     n.Quantity = 0;
    //     n.SpecificationQuantity = true;
    //   } else {
    //     n.Quantity = parseFloat(n.QuantityValue);
    //     n.SpecificationQuantity = false;
    //   }
    // });

    if (this.selectedParentId > 0) {
      this.lgItem.ParentId = parseInt(this.selectedParentId);
    }

    if (this.mode == 'edit') {
      this.laborService.updateLabor(this.lgItem, this.neededParts)
        .subscribe(result => {
          this.dialogRef.close({
            neededParts: this.neededParts,
            laborItem: this.lgItem
          });
        });
    } else {
      // switch (this.mode) {
      //   case 'addTerminal':
      //     this.lgItem.Type = 'Terminal';
      //     break;
      //   default:
      // this.lgItem.Type = 'Category';
      //     break;
      // }

      this.lgItem.Type = 'Category';
      this.lgItem.ParentName = this.parentName;
      this.laborService.addLabor(this.lgItem, this.neededParts).
        subscribe(newLabor => {
          this.isLoading = true;
          this.dialogRef.close({
            neededParts: this.neededParts,
            laborItem: newLabor
          });
        });
    }
  }

  changeQuantity(value, item) {
    if (value > 0) {
      item.SpecificationQuantity = 0;
    }
  }

  selectSpec(ev, item) {
    if (ev.value > 0) {
      item.Quantity = 0;
      item.SpecificationQuantity = parseInt(ev.value);
    }
  }

  deletePart(part) {
    var index = this.neededParts.indexOf(part);
    this.neededParts.splice(index, 1);
  }

  filterNeededParts() {
    return this.neededParts.filter(n => !n.IsDelete);
  }

  isAvalaibleForSave() {
    if (this.lgItem.Title == '') {
      return true;
    } else if (this.isLoading) {
      return true;
    }
    return false;
  }

  // addNewItemByClick() {
  //   let newItem: NeededPartItem = {
  //     NeededPartId: 0,
  //     Name: '',
  //     Location: '',
  //     Quantity: 0,
  //     SpecificationQuantity: false,
  //     IsDelete: false,
  //     IsSupply: false,
  //     QuantityValue: ""
  //   }
  //   this.neededParts.push(newItem);
  // }

  // addNewItem(index = 0) {
  //   let filteredNeededPart = this.neededParts.filter(n => !n.IsDelete);
  //   if (index == filteredNeededPart.length) {
  //     let newItem: NeededPartItem = {
  //       NeededPartId: 0,
  //       Name: '',
  //       Location: '',
  //       Quantity: 0,
  //       SpecificationQuantity: false,
  //       IsDelete: false,
  //       IsSupply: false,
  //       QuantityValue: ""
  //     }
  //     this.neededParts.push(newItem);
  //   }
  // }
  // openProdemand(): void {
  //   this.openDialog();
  // }

  // openDialog(): void {
  //   let dialogRef = this.dialog.open(LaborsearchComponent, {
  //     disableClose: true,
  //     width: '80%',
  //     height: '80%',
  //     data: {
  //       currentVinNumber: this.currentVinNumber,
  //       prodemandPath: this.lgItem.ProdemandPath,
  //       allDataPath: this.lgItem.AllDataPath,
  //     }
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result.action == 'save') {
  //       this.lgItem.ProdemandPath = result.prodemandPath;
  //       this.lgItem.AllDataPath = result.allDataPath;
  //     }
  //   });
  // }
}
